import { Button } from "@mui/material";
import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  createPortfolio,
  getPortfolio,
} from "../../../feature/portfolio/portfolioSlice";
import "./createPortfolio.scss";
import EditorToolbar, { formats, modules } from "./EditorToolbar";

const CreatePortfolio = () => {
  const [portData, setPortData] = useState({
    title: "",
    technology: "",
    category: "",
    liveLink: "",
    gitClient: { value: `` },
    gitServer: { value: `` },
  });
  const [image, setImage] = useState("");
  const [imgUrl, setImgUrl] = useState(null);

  const { title, technology, category, liveLink, gitClient, gitServer } =
    portData;
  const [body, setBody] = useState({ value: null });
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPortData({ ...portData, [name]: value });
  };

  const inputClear = () => {
    setPortData({
      title: "",
      technology: "",
      category: "",
      liveLink: "",
      gitClient: { value: `` },
      gitServer: { value: `` },
    });
    setBody({ value: null });
  };

  const handleImgUpload = () => {
    const myData = new FormData();
    myData.append("file", image);
    myData.append("upload_preset", "portfolio");
    myData.append("cloud_name", "djwncpbir");

    fetch("https://api.cloudinary.com/v1_1/djwncpbir/image/upload", {
      method: "post",
      body: myData,
    })
      .then((res) => res.json())
      .then((data) => setImgUrl(data.url))
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSumbit = (e) => {
    e.preventDefault();
    const portfolioData = {
      title,
      image: imgUrl,
      technology,
      category,
      liveLink,
      gitClient,
      gitServer,
      body,
    };
    dispatch(createPortfolio(portfolioData));
    inputClear();
    toast.success("Portfolio Created successfully", {
      position: "bottom-right",
      autoClose: 3000,
      theme: "dark",
      pauseOnHover: true,
      draggable: true,
      Limit: 1,
    });
    dispatch(getPortfolio());
  };

  return (
    <div className="create-portfolio-container">
      <h2>Create Portfolio: </h2>
      <div className="inp-portfolio">
        <form onSubmit={handleSumbit}>
          <input
            className="title common-input"
            type="text"
            name="title"
            onChange={handleChange}
            value={title}
            placeholder="Title"
          />
          <br />
          <div className="file-inp">
            <input
              type="file"
              name="image"
              onChange={(e) => setImage(e.target.files[0])}
            />
            <Button className="img-btn" onClick={handleImgUpload}>
              Upload
            </Button>
          </div>
          <input
            className="common-input"
            type="text"
            name="technology"
            onChange={handleChange}
            value={technology}
            placeholder="Technology"
          />
          <div className="half-inp">
            <input
              className="common-input"
              type="text"
              name="category"
              onChange={handleChange}
              value={category}
              placeholder="Category"
            />
            <input
              className="common-input"
              type="text"
              name="liveLink"
              onChange={handleChange}
              value={liveLink}
              placeholder="Live Link"
            />
          </div>
          <div className="half-inp">
            <textarea
              className="common-input"
              type="text"
              name="gitClient"
              onChange={handleChange}
              value={gitClient.value}
              placeholder="Git Client"
            ></textarea>

            <textarea
              className="common-input"
              type="text"
              name="gitServer"
              onChange={handleChange}
              value={gitServer.value}
              placeholder="Git Server"
            ></textarea>
          </div>
          <div className="text-editor">
            <EditorToolbar />
            <ReactQuill
              className="text-aria"
              theme="snow"
              value={body.value}
              onChange={(value) => setBody({ value })}
              placeholder={"Write Your Blog..."}
              modules={modules}
              formats={formats}
            />
          </div>
          <Button className="submit-btn" type="submit">
            Submit
          </Button>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
};

export default CreatePortfolio;
